/**
 * Cross-route handoff for a viewpoint captured in the viewer that the
 * user wants to attach to a new BCF topic.
 *
 * Onda 3 of the client-side pivot: instead of stashing the full
 * Viewpoint payload in sessionStorage, we capture into the
 * IndexedDB-backed `viewpointsStore` (so it shows up in the viewpoints
 * panel and survives reloads) and only stash the resulting id. The
 * new-topic form looks the id up at submit time and attaches it to
 * the freshly created topic. Cleared explicitly once consumed.
 */
const KEY = 'vn2r.bcf.pendingViewpointId'

export function setPendingViewpointId(id: string): void {
  try {
    sessionStorage.setItem(KEY, id)
  } catch {
    /* quota / private mode, best effort */
  }
}

export function readPendingViewpointId(): string | null {
  try {
    return sessionStorage.getItem(KEY)
  } catch {
    return null
  }
}

export function clearPendingViewpointId(): void {
  try {
    sessionStorage.removeItem(KEY)
  } catch {
    /* ignore */
  }
}
